"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizationService = void 0;
var fifty_seven_llc_protocol_1 = require("fifty-seven-llc-protocol");
var api_1 = require("../common/api");
var fifty_seven_llc_common_1 = require("fifty-seven-llc-common");
var store_1 = require("../../store");
var AuthorizationService = (function () {
    function AuthorizationService() {
    }
    AuthorizationService.prototype.signIn = function (login, password) {
        return new Promise(function (resolve, reject) {
            fetch('/authorization/sign_in', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ login: login, password: password }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    switch (res.error) {
                        case fifty_seven_llc_common_1.AuthorizationErrorEnum.invalidLogin:
                        case fifty_seven_llc_common_1.AuthorizationErrorEnum.invalidPassword: {
                            reject('Invalid login or password.');
                            break;
                        }
                        case fifty_seven_llc_common_1.AuthorizationErrorEnum.internalServer: {
                            reject('Internal server error.');
                            break;
                        }
                        default: {
                            reject(res.error);
                        }
                    }
                }
                else {
                    resolve(res.result.accessToken);
                }
            })
                .catch(function (err) {
                reject(err.message);
            });
        });
    };
    AuthorizationService.prototype.signOut = function () {
        return new Promise(function (resolve, reject) {
            store_1.store.dispatch('account/clearList');
            store_1.store.dispatch('company/clearList');
            store_1.store.dispatch('permission/clearList');
            fetch('/authorization/sign_out')
                .then(function (res) { return resolve(); })
                .catch(function (err) { return reject(err.message); });
        });
    };
    AuthorizationService.prototype.authorize = function (accessToken) {
        return new Promise(function (resolve) {
            var callback = function (message) {
                if (message instanceof fifty_seven_llc_protocol_1.ServerPb.Authorize) {
                    if (message.hasError()) {
                        switch (message.getError()) {
                            case fifty_seven_llc_common_1.AuthorizationErrorEnum.accessTokenIsInvalid:
                            case fifty_seven_llc_common_1.AuthorizationErrorEnum.internalServer: {
                                resolve(false);
                            }
                        }
                    }
                    else {
                        try {
                            var accessTokenData = JSON.parse(atob(accessToken.split('.')[1]));
                            if (!accessTokenData['accountId'])
                                return resolve(false);
                            resolve(true);
                        }
                        catch (err) {
                            console.error(err);
                            resolve(false);
                        }
                    }
                    api_1.api.off('message', callback);
                }
            };
            api_1.api.on('message', callback);
            var message = new fifty_seven_llc_protocol_1.ClientPb.Authorize();
            message.setAccessToken(accessToken);
            api_1.api.send(message, true);
        });
    };
    AuthorizationService.prototype.refreshToken = function () {
        return new Promise(function (resolve) {
            fetch('/authorization/refresh_token')
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    console.error('Authorization error:', fifty_seven_llc_common_1.AuthorizationErrorEnum[res.error] || res.error);
                    resolve(null);
                }
                else {
                    resolve(res.result.accessToken);
                }
            })
                .catch(function (err) { return resolve(null); });
        });
    };
    return AuthorizationService;
}());
exports.authorizationService = new AuthorizationService();
//# sourceMappingURL=authorization.service.js.map